export const SupplierValidation = (formData) => {
    const errors = {};

    if (!formData.formData.vc_SupplierName || !formData.formData.vc_SupplierName.trim()) {
        errors.vc_SupplierName = 'This field is required';
    }



    if (!formData.formData.vc_FirstName || !formData.formData.vc_FirstName.trim()) {
        errors.vc_FirstName = 'This field is required';
    }

    if (!formData.formData.vc_SurName || !formData.formData.vc_SurName.trim()) {
        errors.vc_SurName = 'This field is required';
    }

    if (formData.formData.vc_Email) {
        if (!isValidEmail(formData.formData.vc_Email)) {
            errors.vc_Email = 'Please enter a valid email address';
        }
    }

    return errors;
};
const isValidEmail = (email) => {
    // You can implement a regex or use a library like validator.js to validate email format
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};